import * as Sentry from "@sentry/react";
import React from "react";
import {
  useLocation,
  useNavigationType,
  createRoutesFromChildren,
  matchRoutes,
} from "react-router-dom";

// Environment variable access
const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;
const SENTRY_ENVIRONMENT = import.meta.env.VITE_ENVIRONMENT;
const SENTRY_RELEASE = import.meta.env.VITE_APP_VERSION;

if (!SENTRY_DSN) {
  console.warn("Sentry DSN not provided - error tracking will be disabled");
}

Sentry.init({
  dsn: SENTRY_DSN,
  environment: SENTRY_ENVIRONMENT,
  release: SENTRY_RELEASE,

  // Session Replay - 100% in development, 100% in production (due to low traffic volume)
  replaysSessionSampleRate: import.meta.env.PROD ? 1.0 : 1.0,
  // Always capture sessions with errors
  replaysOnErrorSampleRate: 1.0,

  // Enable debug mode only in development
  debug: import.meta.env.DEV,

  // Tracing and Replay
  integrations: [
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect: React.useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
    Sentry.replayIntegration({
      minReplayDuration: 5000, // Minimum duration of a replay session in milliseconds
      // NOTE: This will disable built-in masking. Doing this for intial audit.
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],

  // Performance monitoring configuration
  tracesSampleRate: import.meta.env.PROD ? 1.0 : 1.0, // Sample 100% in production (due to low traffic volume)  , all in development

  // Profile 100% of sampled transactions in production (due to low traffic volume)
  profilesSampleRate: import.meta.env.PROD ? 1.0 : 1.0,

  // Only enable Sentry in production
  // enabled: import.meta.env.PROD,
});
